import ProfileMessagesListService from "@services/profile-messages-list-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { notifyFromAlert } from "../helpers/notifs";

interface ProfileMessagesListProps {
  url: string;
  pageSize: number;
  pageIndex: number;
  type: number;
  links: Links;
}

interface Links {
    profil: string;
}

interface LoadPageEvent {
    EventAction: string;
    EventCat: string;
    EventLibelle: string;
    event: string;
    idCandidat: string;
}

interface ShowTabEvent {
  categoryPage: string;
  idCandidat: string;
  sujetPage: string;
  typePage: string;
  event: string;
}

export default class ProfileMessagesList extends Component {
  private currentMessages: any;
  private fullMessages: any[] = [];
  private elMessagesList: HTMLElement;
  private elMoreLink: HTMLElement;
  private elMessagesEmpty: HTMLElement;
  private elMessagesEmptyTitle: HTMLElement;
  private elMessagesEmptyText: HTMLElement;
  private elMessageWrapper: HTMLDivElement;

  constructor(private props: ProfileMessagesListProps, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    this.injectTemplate();

    initialiseComponents();

    this.elMessagesList = this.element.querySelector("[data-pm-list]");
    this.elMoreLink = this.element.querySelector("[data-pm-more]");
    this.elMessagesEmpty = this.element.querySelector("[data-pm-empty-title]");
    this.elMessagesEmptyTitle = this.element.querySelector(
      "[data-pm-empty-title]"
    );
    this.elMessagesEmptyText = this.element.querySelector(
      "[data-pm-empty-text]"
    );

    if (this.props.url) {
      this.call(this.props.url);
    }
  }
  getParams(): any {
    return {
      pageSize: this.props.pageSize,
      pageIndex: this.props.pageIndex,
      type: this.props.type,
    };
  }
  call(url: string): void {
    const service = new ProfileMessagesListService(url);
    const data = this.getParams();

    this.elMessageWrapper = document.createElement("div");
    this.elMessageWrapper.classList.add("messages-list-wrapper");
    this.elMessagesList.appendChild(this.elMessageWrapper);

    service.setErrorHandler((error: any) => {
      this.displayError();
    });

    service.post(data, (response: any) => {
      if (response.trackingsLoad && response.trackingsLoad.length) {
        const loadPageEvent = response.trackingsLoad.find(
          (event: LoadPageEvent | ShowTabEvent) => {
            return ("EventAction" in event) && (event.EventAction === "Load");
          }
        );

        const showTabEvent = response.trackingsLoad.find(
          (event: LoadPageEvent | ShowTabEvent) => {
            return event !== loadPageEvent;
          }
        )

        // Send load page event
        if (loadPageEvent) {
          window.dataLayer.push(loadPageEvent);
        }

        // Send ShowTabEvent on display of CV seen tab and intermediation tab
        const observer = new IntersectionObserver(function (entries) {
          if (entries[0].intersectionRatio > 0) {
            const trackingsLoad = showTabEvent;
            const typePage = trackingsLoad.typePage;

            // Add "VirtualPageview" to inform that it's a tab change instead of a page load 
            trackingsLoad.event = "VirtualPageview";

            if (typePage.includes("-nonVide") || typePage.includes("-vide")) {
              trackingsLoad.typePage;
            } else if (response.messages.length >= 1) {
              trackingsLoad.typePage = trackingsLoad.typePage + "-nonVide";
            } else {
              trackingsLoad.typePage = trackingsLoad.typePage + "-vide";
            }
            window.dataLayer.push(trackingsLoad);
          }
        });
        observer.observe(this.element);
      }

      // More link management
      if (!response.isLastPage && !this.fullMessages.length) {
        this.elMoreLink.addEventListener("click", () => {
          this.setMoreLink();
        });
        this.elMoreLink.classList.add("show");
      }

      if (response.isLastPage) {
        this.elMoreLink.removeEventListener("click", this.setMoreLink);
        this.elMoreLink.classList.remove("show");
      }

      if (Array.isArray(response.messages)) {
        this.fullMessages = this.fullMessages.concat(response.messages);
      }

      if (!this.fullMessages.length) {
        this.elMessagesEmptyTitle.innerHTML = response.emptyMessage.title;
        this.elMessagesEmptyText.innerHTML = response.emptyMessage.message;
        this.elMessageWrapper.remove();
        this.displayEmpty();
        return false;
      }

      // Display messages
      this.currentMessages = response.messages;
      // Security if there is no new messages
      if (!this.currentMessages.length) {
        this.elMessageWrapper.remove();
        return false;
      }

      this.displayMessages();
    });
  }
  setMoreLink(): void {
    ++this.props.pageIndex;
    this.call(this.props.url);
  }
  displayEmpty(): void {
    this.element.classList.add("empty");
  }
  displayMessages(): void {
    const messages = this.currentMessages;
    for (let i = 0; i < messages.length; i++) {
            const elMessage = document.createElement("div"),
                data = messages[i];

            switch (messages[i].type) {
                case 2:
                    elMessage.setAttribute("data-profile-message-intermediation", JSON.stringify(data));
                    break;
                default:
                    elMessage.setAttribute("data-profile-message-cv-seen", JSON.stringify(data));
            }

            this.elMessageWrapper.appendChild(elMessage);
        }
        initialiseComponents();
  }
  displayError(): void {
    notifyFromAlert(
      {
        Icon: 2,
        Message: "Aïe, une erreur est survenue, rechargez la page et réessayez.",
        AnalyticsTrackings: "",
        sticky: true,
      },
      true
    );
  }
}
